"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomyQuery = void 0;
var base_taxonomy_query_class_1 = require("./base-taxonomy-query.class");
var TaxonomyQuery = /** @class */ (function (_super) {
    __extends(TaxonomyQuery, _super);
    function TaxonomyQuery(config, queryService, taxonomyCodename) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        _this.taxonomyCodename = taxonomyCodename;
        if (!taxonomyCodename) {
            throw Error("Cannot create taxonomy query without codename of the taxonomy");
        }
        return _this;
    }
    /**
    * Gets the runnable Observable
    */
    TaxonomyQuery.prototype.toObservable = function () {
        return _super.prototype.runTaxonomyQuery.call(this, this.taxonomyCodename);
    };
    /**
    * Gets 'Url' representation of query
    */
    TaxonomyQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomyQueryUrl.call(this, this.taxonomyCodename);
    };
    return TaxonomyQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomyQuery = TaxonomyQuery;
//# sourceMappingURL=taxonomy-query.class.js.map